<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
        <div class="column is-offset-2 is-8">
        <div class="box">
          <h1 class="title">ログインしてください</h1>
          <div class="field">
            <div class="control">
              <input class="input" type="text" placeholder="ユーザー名" v-model="loginForm.username">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input class="input" type="password" placeholder="パスワード" v-model="loginForm.password">
            </div>
          </div>
          <div  v-if="loginErrors">
            <span class="has-text-danger has-text-weight-bold is-size-4">{{ loginErrors }}</span>
          </div>
          <button class="button is-link" v-on:click="login">ログイン</button>
        </div>
        </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

// import axios from 'axios';
import { mapState } from 'vuex'

export default {
  data: function() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
    }
  },
  computed: {
    ...mapState({
      apiStatus: state => state.auth.apiStatus,
      loginErrors: state => state.auth.loginErrorMessages
    })
  },
  created () {
    this.clearError()
  },
  methods: {
    async login() {
      this.clearError()
      await this.$store.dispatch('auth/login', {user: this.loginForm})
      if(this.apiStatus){
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push({ path: '/' });
        }
      }
    },
    clearError () {
      this.$store.commit('auth/setLoginErrorMessages', null)
    }
  }
};
</script>